import { render, staticRenderFns } from "./NewBank.vue?vue&type=template&id=275a5f34&"
import script from "./NewBank.vue?vue&type=script&lang=js&"
export * from "./NewBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports